/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleArchivePreviewBodyExpectedVersionExclusiveMin = 0;
export const scheduleArchivePreviewBodyExpectedVersionMax = 9007199254740991;

export const ScheduleArchivePreviewBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(scheduleArchivePreviewBodyExpectedVersionExclusiveMin)
    .max(scheduleArchivePreviewBodyExpectedVersionMax),
});

export type ScheduleArchivePreviewBody = zod.input<typeof ScheduleArchivePreviewBody>;
export type ScheduleArchivePreviewBodyOutput = zod.output<typeof ScheduleArchivePreviewBody>;
